import { Avatar, Divider, Grid, Typography } from "@mui/material";
import React from "react";
import { FlexCenter } from "../../../constant/CustomeStyle";
import Salad from "../../../../assets/images/order/salad.png";

const ProductsList = () => {
  return (
    <div>
      <FlexCenter>
        <TopTitle />
      </FlexCenter>

      {allItems.map((singleItem, index) => (
        <FlexCenter>
          <ProductSection singleItem={singleItem} key={index} />
        </FlexCenter>
      ))}
    </div>
  );
};

const ProductSection = ({ singleItem }) => (
  <div style={{ marginTop: 15, width: 702 }}>
    <Typography
      align="left"
      style={{
        color: "#424242",
        fontWeight: "600",
        fontFamily: `'Noto Sans', sans-serif`,
      }}
    >
      {singleItem.title}
    </Typography>
    <CustomeDivider />

    <ProductCard singleItem={singleItem.items} />
  </div>
);

const ProductCard = ({ singleItem }) => (
  <div style={{ minWidth: 702 }}>
    <Grid
      container
      direction="row"
      justifyContent="space-between"
      alignItems="center"
    >
      {singleItem.map((item, index) => (
        <SingleCard item={item} />
      ))}
    </Grid>
  </div>
);

const SingleCard = ({ item }) => (
  <div
    style={{
      background: "#FFF",
      width: 83.61,
      height: 58.11,
      borderRadius: 4,
      marginBottom: 10,
      cursor: "pointer",
      textAlign: "left",
      cursor: "pointer",
      fontFamily: `Poppins, sans-serif`,
      boxShadow: "rgba(17, 17, 26, 0.1) 0px 1px 0px",
    }}
    // onClick={() => handleSelection(item.title)}
  >
    <Avatar
      sx={{
        width: "100%",
        height: 40,
        borderTopRightRadius: 4,
        borderTopLeftRadius: 4,
      }}
      variant="square"
      src={item.icon}
    />
    <div
      style={{
        marginTop: 5,
        paddingLeft: 10,
        fontWeight: "400",
        color: "#424242",
        fontSize: 6,
      }}
    >
      {item.title}
    </div>
  </div>
);

const TopTitle = () => (
  <FlexCenter
    style={{
      width: 702,
      height: 55.15,
      color: "#FFF",
      background: "#333C4B",
      fontSize: 20,
      fontWeight: "600",
      fontFamily: `Poppins, sans-serif`,
    }}
  >
    Product List
  </FlexCenter>
);

const CustomeDivider = () => (
  <div style={{ paddingBottom: "20px", paddingTop: "4px" }}>
    <Divider
      style={{
        background: "#E5E5E5",
        margin: "0 0 0 0",
        maxWidth: "100%",
        height: "2.25px",
      }}
    />
    <Divider
      style={{
        background: "#CA2129",
        margin: "-3px 0 0 0",
        maxWidth: "151px",
        height: "3px",
      }}
    />
  </div>
);

const items = [
  { title: "Chicken Salad", icon: Salad },
  { title: "Egg Vegetarian", icon: Salad },
  { title: "Tomato Recipi", icon: Salad },
  { title: "Healthy Salad", icon: Salad },
  { title: "Chunky Vegetable", icon: Salad },
  { title: "Chicken Salad", icon: Salad },
  { title: "Egg Vegetarian", icon: Salad },
  { title: "Tomato Recipi", icon: Salad },
  { title: "Healthy Salad", icon: Salad },
  { title: "Chunky Vegetable", icon: Salad },
  { title: "Chunky Vegetable", icon: Salad },
  { title: "Chicken Salad", icon: Salad },
  { title: "Egg Vegetarian", icon: Salad },
  { title: "Tomato Recipi", icon: Salad },
  { title: "Healthy Salad", icon: Salad },
  { title: "Chunky Vegetable", icon: Salad },
];

const items3 = [
  { title: "Chicken Salad", icon: Salad },
  { title: "Egg Vegetarian", icon: Salad },
  { title: "Tomato Recipi", icon: Salad },
  { title: "Healthy Salad", icon: Salad },
  { title: "Chunky Vegetable", icon: Salad },
  { title: "Chicken Salad", icon: Salad },
  { title: "Egg Vegetarian", icon: Salad },
  { title: "Tomato Recipi", icon: Salad },
];

const allItems = [
  { title: "Salad", items: items },
  { title: "Soup", items: items },
  { title: "Fish", items: items3 },
];

export default ProductsList;
